import { Table } from 'semantic-ui-react';

function EmptyLogTable() {
    return (
        <Table fixed>
            <Table.Body>
                <Table.Row>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                </Table.Row>
            </Table.Body>
        </Table>
    );
}

export default EmptyLogTable;
